import $ from "jquery";
import lax from "lax.js";
window.$ = window.jQuery = $;

const CalculMain = () => {
	let hauteurHeader = document.getElementById("header").offsetHeight;
	let hauteurFooter = document.getElementById("footer").offsetHeight;
	let browserHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	let main = document.getElementById("main");
	main.style.minHeight = browserHeight - (hauteurHeader + hauteurFooter) + "px";
};
const scrollActions = () => {
	let scrollposition = window.scrollY;
	let header = document.getElementById("header");
	if (scrollposition >= 300) {
		header.classList.add("scrolled");
		header.classList.add("scrolledtwice");
	} else {
		header.classList.remove("scrolled");
		header.classList.remove("scrolledtwice");
	}
};
const SetReponseOffre = () => {
	if (document.getElementById("formulaire_reponse") && document.getElementById("form-field-offre")) {
		let offres = document.querySelectorAll(".job h2");
		let select_field = document.getElementById("form-field-offre");
		offres.forEach(el => {
			var opt = document.createElement("option");
			opt.appendChild(document.createTextNode(el.innerText));
			opt.value = el.innerText;
			select_field.appendChild(opt);
		});
	}
};
const filter = theme => {
	let events = document.querySelectorAll(".liste .event");
	let active = document.querySelectorAll(".filtre-agenda.active");
	if (active.length > 0) {
		events.forEach(item => {
			if (!item.classList.contains(theme)) {
				item.classList.add("masked");
			} else {
				item.classList.remove("masked");
			}
		});
	} else {
		events.forEach(item => {
			item.classList.remove("masked");
		});
	}
};
const initFilters = () => {
	if (document.getElementById("evenements")) {
		var filtres = document.querySelectorAll(".filtre-agenda");
		filtres.forEach(item => {
			item.addEventListener("click", () => {
				filtres.forEach(x => {
					x.classList.remove("active");
				});
				item.classList.add("active");
				filter(item.dataset.theme);
			});
		});
	}
};
const initMobileMenu = () => {
	if (document.getElementById("header-mobile")) {
		console.log("je suis en responsive");
		let header_mobile = document.querySelector("#header-mobile");
		let switcher = document.querySelector("#header-mobile .switcher");
		switcher.addEventListener("click", () => {
			if (header_mobile.classList.contains("deploy")) {
				header_mobile.classList.remove("deploy");
			} else {
				header_mobile.classList.add("deploy");
			}
		});
	}
};

// JQUERY
(function($) {
	function init() {
		document.addEventListener(
			"resize",
			() => {
				CalculMain();
			},
			{ passive: true }
		);
		document.addEventListener("scroll", scrollActions, { passive: true });
		CalculMain();
		SetReponseOffre();
		initFilters();
		initMobileMenu();
	}

	init();
})(jQuery);
